import { useEffect } from 'react';
const useMountEffect = callback => useEffect(callback, []);
export default useMountEffect;
//# sourceMappingURL=index.js.map